import _ from 'lodash';

const TEMPLATE_NAME = 'PATIENTS_PEP';

const initialState = () => ({
  loading: false,
  fetched: false,
  loadedData: [],
  filter: {
    term: '',
    data: []
  }
});

const reducer = (state = initialState(), action) => {
  switch (action.type) {
    case `${TEMPLATE_NAME}_PENDING`: {
      return {
        ...state,
        loading: true,
        fetched: false
      };
    }

    case `${TEMPLATE_NAME}_REJECTED`: {
      return {
        ...state,
        loading: false,
        fetched: true
      };
    }

    case `${TEMPLATE_NAME}_FULFILLED`: {
      // const currentData = state.loadedData;
      const newData = action.payload;

      return {
        ...state,
        loading: false,
        fetched: true,
        loadedData: newData,
        filter: {
          ...state.filter,
          data: newData
        }
      };
    }

    case `${TEMPLATE_NAME}_PERPAGE_PENDING`: {
      return {
        ...state,
        loading: true,
        fetched: true
      };
    }

    case `${TEMPLATE_NAME}_PERPAGE_FULFILLED`: {
      const currentData = state.loadedData;
      const newData = action.payload;

      return {
        ...state,
        loading: false,
        fetched: true,
        loadedData: [...currentData, ...newData],
        filter: {
          ...state.filter,
          data: !_.isEmpty(newData) ? [...currentData, ...newData] : currentData
        }
      };
    }

    case `${TEMPLATE_NAME}_SEARCH_PENDING`: {
      return {
        ...state,
        loading: true
      };
    }

    case `${TEMPLATE_NAME}_SEARCH_REJECTED`: {
      return {
        ...state,
        loading: false
      };
    }

    case `${TEMPLATE_NAME}_SEARCH_FULFILLED`: {
      const { data } = action.payload;
      return {
        ...state,
        loading: false,
        filter: {
          ...state.filter,
          data
        }
      };
    }

    case `${TEMPLATE_NAME}_RESET`: {
      return initialState();
    }

    default:
      return state;
  }
};

export default reducer;
